(() => {
  if (window.mgAnnouncementPreviewReady) return;
  window.mgAnnouncementPreviewReady = true;
  const instances = new Map();

  function initialize(scope = document) {
    scope.querySelectorAll('[data-announcement-preview]').forEach(root => {
      if (instances.has(root)) return;
      const triggers = [...root.querySelectorAll('[data-announcement-preview-trigger]')];
      const card = root.querySelector('[data-announcement-preview-card]');
      if (!triggers.length || !card) return;
      const controller = new AbortController();
      const signal = controller.signal;
      const productLink = card.querySelector('.mg-announcement-preview__link');
      let activeTrigger = triggers[0];
      let closeTimer;
      let touch = false;
      let wasOpen = false;
      let suppressFocus = false;

      // Escape the header's stacking and clipping while retaining keyboard order.
      document.body.appendChild(card);
      const listen = (target, event, callback, options = {}) =>
        target.addEventListener(event, callback, { ...options, signal });
      const cancelClose = () => window.clearTimeout(closeTimer);

      function close() {
        cancelClose();
        card.hidden = true;
        triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      }

      function position() {
        const rect = activeTrigger.getBoundingClientRect();
        const width = card.offsetWidth;
        const left = Math.max(12, Math.min(rect.left + rect.width / 2 - width / 2, window.innerWidth - width - 12));
        card.style.left = `${left}px`;
        card.style.top = `${rect.bottom + 12}px`;
        card.style.maxHeight = `${Math.max(100, window.innerHeight - rect.bottom - 24)}px`;
        card.style.overflowY = card.scrollHeight > window.innerHeight - rect.bottom - 24 ? 'auto' : 'visible';
        card.style.setProperty('--preview-arrow-left', `${Math.max(16, Math.min(width - 16, rect.left + rect.width / 2 - left))}px`);
      }

      function open(trigger) {
        cancelClose();
        activeTrigger = trigger;
        card.hidden = false;
        triggers.forEach(item => item.setAttribute('aria-expanded', String(item === trigger)));
        position();
      }

      function scheduleClose() {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!card.matches(':hover') && !triggers.some(trigger => trigger.matches(':hover')) &&
              !card.contains(document.activeElement) && !triggers.includes(document.activeElement)) close();
        }, 180);
      }

      function focusTrigger() {
        suppressFocus = true;
        activeTrigger.focus({ preventScroll: true });
        suppressFocus = false;
      }

      triggers.forEach(trigger => {
        listen(trigger, 'pointerenter', event => { if (event.pointerType !== 'touch') open(trigger); });
        listen(trigger, 'pointerleave', scheduleClose);
        listen(trigger, 'pointerdown', event => {
          touch = event.pointerType === 'touch';
          wasOpen = !card.hidden && activeTrigger === trigger;
        });
        listen(trigger, 'focus', () => { if (!suppressFocus && !touch) open(trigger); });
        listen(trigger, 'blur', scheduleClose);
        listen(trigger, 'click', event => {
          if (touch && !wasOpen) { event.preventDefault(); open(trigger); }
          touch = false;
        });
        listen(trigger, 'keydown', event => {
          if (event.key === 'Tab' && !event.shiftKey && !card.hidden) {
            event.preventDefault();
            productLink.focus();
          } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            open(trigger);
            productLink.focus();
          }
        });
      });

      listen(productLink, 'keydown', event => {
        if (event.key !== 'Tab') return;
        focusTrigger();
        if (event.shiftKey) event.preventDefault();
        else close();
      });
      listen(card, 'pointerenter', cancelClose);
      listen(card, 'pointerleave', scheduleClose);
      listen(card, 'focusin', cancelClose);
      listen(card, 'focusout', scheduleClose);
      listen(document, 'keydown', event => {
        if (event.key === 'Escape' && !card.hidden) {
          if (card.contains(document.activeElement)) focusTrigger();
          close();
        }
      });
      listen(document, 'pointerdown', event => {
        if (!card.contains(event.target) && !triggers.some(trigger => trigger.contains(event.target))) close();
      });
      listen(window, 'resize', close);
      listen(window, 'scroll', event => {
        if (!card.contains(event.target)) close();
      }, { passive: true, capture: true });
      instances.set(root, () => { cancelClose(); controller.abort(); card.remove(); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (event.target.contains(root)) { cleanup(); instances.delete(root); }
    });
  });
})();
